module.exports = __webpack_public_path__ + "img/Airplane Bingo.575d97ff.jpeg";